import React, { Component } from 'react';

class Incidents extends Component {
	render() {
		let incidenciasDiarias = [];

		if (this.props.incidentesHoy) {
			incidenciasDiarias = this.props.incidentesHoy;
		}

		return (
			<div className="incidents">
				<div className="card-table card-incident column">
					<div className="title">
						<h4>Incidencias del día</h4>
					</div>
					{this.props.incidentesHoy.length !== 0 ? (
						<div className="table-responsive">
							<table>
								<thead>
									<tr className="text-left">
										<th className="name text-left">Tipo</th>
										<th className="description text-left">Descripción</th>
										<th className="date text-left">Teléfono</th>
									</tr>
								</thead>
								<tbody>
									{incidenciasDiarias.map((incidencia, key) => (
										<tr key={key}>
											<td className="text-left">{incidencia.Tipo}</td>
											<td className="description-detail text-left">{incidencia.descripcion}</td>
											<td className="text-left">{incidencia.telefono}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					) : (
						<b>Sin Incidencias</b>
					)}
				</div>
			</div>
		);
	}
}

export default Incidents;
